import { render, staticRenderFns } from "./sprojectQuotaList.vue?vue&type=template&id=375fbb0e&scoped=true&"
import script from "./sprojectQuotaList.vue?vue&type=script&lang=js&"
export * from "./sprojectQuotaList.vue?vue&type=script&lang=js&"
import style0 from "./sprojectQuotaList.vue?vue&type=style&index=0&id=375fbb0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375fbb0e",
  null
  
)

export default component.exports